// extracted by mini-css-extract-plugin
export default {"container":"stats-panel_container__zM+W3","title":"stats-panel_title__Ycj6V","count":"stats-panel_count__Lom5K"};